module.exports = __webpack_public_path__ + "img/logo.0c18fc24.png";